import { render, staticRenderFns } from "./PollOption.vue?vue&type=template&id=8a20bbba&scoped=true"
import script from "./PollOption.vue?vue&type=script&lang=js"
export * from "./PollOption.vue?vue&type=script&lang=js"
import style0 from "./PollOption.vue?vue&type=style&index=0&id=8a20bbba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a20bbba",
  null
  
)

export default component.exports